const runScriptOnReady = require('public/js/lib/run-script-on-ready');
const { PRODUCT_QUANTITY } = require('public/js/constants/product_quantity');

/* global rp$ */
function productQuantity() {
	const $increaseBtn = rp$(".quantity-btn.plus");
	const $decreaseBtn = rp$(".quantity-btn.minus");
	const $quantityInput = rp$(".quantity-display");

	function updateQuantity(quantity, skuStripped, maxValue, $currentIncreaseBtn, $currentDecreaseBtn) {
		// Set the quantity for both mobile and desktop element
		rp$(`.quantity-display[data-sku-stripped="${skuStripped}"]`).each(function (index, element) {
			const $quantity = rp$(this);
			$quantity.val(quantity);
		});

		// Update button states based on quantity
		$currentIncreaseBtn.prop('disabled', quantity >= maxValue);
		$currentDecreaseBtn.prop('disabled', quantity <= 1);
	}

	// Validate input and reset to 1 if invalid
	function validateQuantity(value, maxValue, returnEmpty = false) {
		// If returnEmpty is true and value is falsy, return an empty string
		if (returnEmpty && !value) {
			return "";
		}

		// Ensure the value is within bounds: between 1 and maxValue
		return Math.max(1, Math.min(maxValue, value || 1));
	}

	$quantityInput.on("change", function (e) {
		const $quantity = rp$(this);
		const skuStripped = $quantity.data('sku-stripped');
		const maxValue = $quantity.attr('max') || PRODUCT_QUANTITY.MAX_QUANTITY_LIMIT;

		const $currentIncreaseBtn = $quantity.siblings(`.quantity-btn.plus`);
		const $currentDecreaseBtn = $quantity.siblings(`.quantity-btn.minus`);

		// Validate and update quantity based on user input
		const quantity = validateQuantity(parseInt($quantity.val()), maxValue);
		updateQuantity(quantity, skuStripped, maxValue, $currentIncreaseBtn, $currentDecreaseBtn);
	});

	$quantityInput.on("input", function (e) {
		const $quantity = rp$(this);
		const skuStripped = $quantity.data('sku-stripped');
		const maxValue = $quantity.attr('max') || PRODUCT_QUANTITY.MAX_QUANTITY_LIMIT;

		const $currentIncreaseBtn = $quantity.siblings(`.quantity-btn.plus`);
		const $currentDecreaseBtn = $quantity.siblings(`.quantity-btn.minus`);

		// Validate and update quantity based on user input
		const quantity = validateQuantity(parseInt($quantity.val()), maxValue, true);
		updateQuantity(quantity, skuStripped, maxValue, $currentIncreaseBtn, $currentDecreaseBtn);
	});

	$quantityInput.on("keydown", function(e) {
		// Prevent Enter key from triggering form submission
		if (e.key === "Enter" || e.keyCode === 13) {
			e.preventDefault();
		}
	});

	$increaseBtn.on("click", function () {
		const $currentIncreaseBtn = rp$(this);
		const $currentDecreaseBtn = $currentIncreaseBtn.siblings(`.quantity-btn.minus`);

		// Find the quantity element with the same class on the same level
		const $quantity = $currentIncreaseBtn.siblings(`.quantity-display`);
		const skuStripped = $quantity.data('sku-stripped');
		const maxValue = $quantity.attr('max') || PRODUCT_QUANTITY.MAX_QUANTITY_LIMIT;
		
		// Increase quantity and validate it
		const quantity = validateQuantity(parseInt($quantity.val()) + 1, maxValue);
		updateQuantity(quantity, skuStripped, maxValue, $currentIncreaseBtn, $currentDecreaseBtn);
	});

	$decreaseBtn.on("click", function () {
		const $currentDecreaseBtn = rp$(this);
		const $currentIncreaseBtn = $currentDecreaseBtn.siblings(`.quantity-btn.plus`);

		// Find the quantity element with the same class on the same level
		const $quantity = $currentDecreaseBtn.siblings(`.quantity-display`);
		const skuStripped = $quantity.data('sku-stripped');
		const maxValue = $quantity.attr('max') || PRODUCT_QUANTITY.MAX_QUANTITY_LIMIT;
		
		// Decrease quantity and validate it
		const quantity = validateQuantity(parseInt($quantity.val()) - 1, maxValue);
		updateQuantity(quantity, skuStripped, maxValue, $currentIncreaseBtn, $currentDecreaseBtn);
	});
}

rp$.fn.product_quantity = productQuantity;

runScriptOnReady('product_quantity', productQuantity);
